import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20warm%20gradient%20abstract%20background%20with%20flowing%20geometric%20shapes%20in%20coral%20and%20gold%20tones%2C%20Asian-inspired%20minimalist%20design%2C%20soft%20layered%20textures%2C%20sophisticated%20and%20modern%20aesthetic%2C%20warm%20cream%20undertones&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="亚洲一区二区 - 精选内容导航"
          className="w-full h-full object-cover"
          title="亚洲一区二区精选内容汇总"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-accent-300 text-sm md:text-base font-label tracking-widest mb-3 uppercase">
            {heroData.subtitle}
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {heroData.title}
          </h1>
          <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to={heroData.ctaPrimaryLink}
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full font-label font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              {heroData.ctaPrimary}
            </Link>
            <Link
              to={heroData.ctaSecondaryLink}
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full font-label font-semibold text-sm whitespace-nowrap hover:bg-white/25 transition-all duration-300 cursor-pointer"
            >
              {heroData.ctaSecondary}
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 md:gap-12">
            {heroData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}